import React, { useEffect, useMemo, useState } from 'react';
import { Box, Checkbox, CircularProgress, Paper, TextField, Typography } from '@mui/material';
import { format } from 'date-fns';
import useFetch from '../../../../hooks/useFetch.js';
import { getV2Competitions, postV2Live } from '../../../../../api/index.js';
import CompetitionDTO from '../../../../DTO/CompetitionDTO.js';
import SearchFilterDTO from '../../../../DTO/SearchFilterDTO.js';
import LiveDTO from '../../../../DTO/LiveDTO.js';
import { useNavigate } from 'react-router-dom';
import { getUserProvider } from '../../../../../actions/auth.js';
import { useNotifications } from '../../../../notifications/NotificationManager.js';
import { getRootUrl } from '../../../../../api/infoEnv.js';
import Button from '../../../../components/Button.js';

const defaultLiveData = new LiveDTO({ name : "", date : new Date().toISOString(), provider : getUserProvider() })

const FormLive = () => {

    const navigate = useNavigate()

    const { addNotification } = useNotifications();

    const [formLive, setFormLive] = useState(defaultLiveData)

    const [searchFilter, setSearchFilter] = useState(new SearchFilterDTO({
                                                                            competition : { _id : []},
                                                                            sport : { _id : []},
                                                                            discipline : { _id : []},
                                                                            phase : { _id : []}
                                                                        }))

    const { data, isLoading, error, fetchData } = useFetch(postV2Live, [{ live : formLive, filter : searchFilter}]);

    useEffect(() => {

        if(!data)
            return

        // Envoyer une notif au service de notification
        addNotification({
            title: 'Création d\'un direct',
            type: 'success',
            description: 'Votre direct a été créée avec succès !',
            link: getRootUrl() +'/lives/'+data._id+'/calendar'
        });

        // Rediriger vers la page des lives
        navigate("/multisport/events/lives");

    }, [data])

    useEffect(() => {

        console.log("Error", error)

    }, [error])

    const handleChange = (e) => {

        const {name, value} = e.target

        setFormLive(s => ({...s, [name] : value}))
    }

    const isValidForm = useMemo(() => {
        return formLive.name && formLive.date && formLive.provider && searchFilter.competition._id && searchFilter.competition._id.length === 1
    }, [formLive, searchFilter])

    const handleSubmit = async () => {
        // Controles du form
        if(!isValidForm)
            return

        fetchData()
    }


    if(isLoading)
        return <CircularProgress/>

    return <Paper sx={{textAlign : 'center', p : 3}}>

        <Typography sx={{mb : 2 }} variant='h5'>Création de mon direct</Typography>

        <TextField name="name" label="Nom" onChange={handleChange} value={formLive.name}/>

        <TextField
            label="Date & heure"
            name="date"
            type="datetime-local"
            value={formLive.date && format(new Date(formLive.date), "yyyy-MM-dd'T'HH:mm")}
            InputLabelProps={{
                shrink: true,
            }}
            onChange={handleChange}
        />

        

        <Box sx={{textAlign : 'left'}}>
            <Typography sx={{mt : 2, fontSize : '1.2em'}} variant="subtitle2">Compétitions de mon live</Typography>
            <CompetitionsFilters searchFilter={searchFilter} setSearchFilter={setSearchFilter}/>
        </Box>

        <Button onClick={handleSubmit} disabled={!isValidForm}>VALIDER MON FORMULAIRE</Button>

    </Paper>

}

const groupCompetitionDisciplinesBySport = (competitions) => {

    
   
    competitions.forEach(competition => {

        const groupedDisciplines = {};

        competition.competitionsDisciplines.forEach(competitionDiscipline => {
            const { discipline } = competitionDiscipline;
            const sport = discipline.sport; // Récupérer le sport depuis la discipline

            if (!groupedDisciplines[sport._id]) {
                groupedDisciplines[sport._id] = {
                    sport,
                    competitionDisciplines: []
                };
            }

            groupedDisciplines[sport._id].competitionDisciplines.push(competitionDiscipline);

        });

        competition.groupedDisciplines = groupedDisciplines;

    });

    return competitions;
};

const CompetitionsFilters = ({searchFilter, setSearchFilter}) => {

    const provider = getUserProvider()
    const { data, isLoading, error, fetchData  } = useFetch(getV2Competitions, [provider]);

    const [competitions, setCompetitions] = useState()

    useEffect(() => {
        fetchData()
    }, [])

    useEffect(() => {
        if(!data)
            return

        const myDTOS = data.map(d => new CompetitionDTO(d))

        setCompetitions(groupCompetitionDisciplinesBySport(myDTOS))

    }, [data])

    if (isLoading) return <div>Chargement...</div>;
    if (error) return <div>Erreur : {error.message}</div>;

   return (
        <div>
          {competitions && competitions.map(c => <CompetitionFilter competition={c} searchFilter={searchFilter} setSearchFilter={setSearchFilter}/>)}
        </div>
      );
}


function getValueByPath(obj, path) {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
}

const CompetitionFilter = ({competition, searchFilter, setSearchFilter}) => {


    const checkIsChecked = (name, value) => {
        const attribute = getValueByPath(searchFilter, name)

        return attribute?.includes(value)
    }

    const handleCheckboxChange = (e, value, level, competitionDisciplines) => {
        const {name, checked} = e.target

        const newSearchFilter = {...searchFilter}

        const attribute = getValueByPath(newSearchFilter, name)

        // Verifier si l'attribut 'name' de mon search contient ou non 'value' en fonction de 'checked'
        if(checked){
            if(attribute && !attribute.includes(value))
                attribute.push(value)
        }else{
            if(attribute && attribute.includes(value)) {
                const index = attribute.indexOf(value);
                if (index !== -1) {
                    attribute.splice(index, 1);
                }
            }
            competitionDisciplines && unCheckHierarchy(level, competitionDisciplines)
        }

        setSearchFilter(newSearchFilter)
    }

    const handleDateChange = (e) => {
        const {name, value} = e.target

        const newSportEventSearchFilter = {...searchFilter.sportevent}

        newSportEventSearchFilter[name] = value

        setSearchFilter(s => ({...s, sportevent : newSportEventSearchFilter}))
    }

    const unCheckHierarchy = (level, competitionDisciplines) => {

        const newSearchFilter = {...searchFilter};

        competitionDisciplines.forEach(competitionDiscipline => {

            if (['sport'].includes(level)){
                //décocher le sport : recup l'id et virer du searchFilter
                const checkedSportId = competitionDiscipline.discipline.sport._id;

                if(newSearchFilter.sport._id && newSearchFilter.sport._id.includes(checkedSportId)) {
                    const index = newSearchFilter.sport._id.indexOf(checkedSportId);
                    if (index !== -1) {
                        newSearchFilter.sport._id.splice(index, 1);
                    }
                }
            }

            //décocher la discipline : recup les ids et virer du searchFilter
            const checkedDisciplineId = competitionDiscipline.discipline._id

            if(newSearchFilter.discipline._id && newSearchFilter.discipline._id.includes(checkedDisciplineId)) {
                const index = newSearchFilter.discipline._id.indexOf(checkedDisciplineId);
                if (index !== -1) {
                    newSearchFilter.discipline._id.splice(index, 1);
                }
            }

            //décocher la phase : recup les ids et virer du searchFilter
            const checkedPhaseIds = competitionDiscipline.phases.map(phase => phase._id);

            checkedPhaseIds.forEach(checkedPhaseId => {
                if(newSearchFilter.phase._id && newSearchFilter.phase._id.includes(checkedPhaseId)) {
                    const index = newSearchFilter.phase._id.indexOf(checkedPhaseId);
                    if (index !== -1) {
                        newSearchFilter.phase._id.splice(index, 1);
                    }
                }
            })
           
        }
    )

    setSearchFilter(newSearchFilter);

}


    return (
        <Box>
        <Checkbox name="competition._id" onChange={(e) => handleCheckboxChange(e, competition._id, 'sport', competition.competitionsDisciplines)} />
        <Typography component="span">{competition.name}</Typography>
        {checkIsChecked("competition._id", competition._id) && (
            <Box sx={{ pl: 3 }}>
                <TextField
                    label="Date de début"
                    name="beginDate"
                    type="datetime-local"
                    value={searchFilter.sportevent.beginDate && format(new Date(searchFilter.sportevent.beginDate), "yyyy-MM-dd'T'HH:mm")}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={handleDateChange}
                />
                <TextField
                    label="Date de fin"
                    name="endDate"
                    type="datetime-local"
                    value={searchFilter.sportevent.endDate && format(new Date(searchFilter.sportevent.endDate), "yyyy-MM-dd'T'HH:mm")}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    onChange={handleDateChange}
                />
                {competition.groupedDisciplines && Object.values(competition.groupedDisciplines).map(groupedCompDiscipl => (
                    <Box key={groupedCompDiscipl.sport._id}>
                        <Checkbox name={"sport._id"} checked={searchFilter.sport?._id?.includes(groupedCompDiscipl.sport._id)} onChange={(e) => handleCheckboxChange(e, groupedCompDiscipl.sport._id, 'discipline', Object.values(groupedCompDiscipl.competitionDisciplines))} />
                        <Typography component="span">{groupedCompDiscipl.sport.label}</Typography>
                        {checkIsChecked("sport._id", groupedCompDiscipl.sport._id) && Object.values(groupedCompDiscipl.competitionDisciplines).map(competitionDiscipline => (
                            <Box key={competitionDiscipline._id} sx={{ pl: 3 }}>
                                <Checkbox name="discipline._id" checked={searchFilter.discipline?._id?.includes(competitionDiscipline.discipline?._id)} onChange={(e) => handleCheckboxChange(e, competitionDiscipline.discipline._id,'phase',[competitionDiscipline])} />
                                <Typography component="span">{competitionDiscipline.discipline?.label}</Typography>
                                {checkIsChecked("discipline._id", competitionDiscipline.discipline._id) && competitionDiscipline.phases.map(phase => (
                                    <Box key={phase._id} sx={{ pl: 6 }}>
                                        <Checkbox name="phase._id" checked={searchFilter.phase?._id?.includes(phase?._id)} onChange={(e) => handleCheckboxChange(e, phase._id)} />
                                        <Typography component="span">{phase.name} - {phase.category.name} - {phase.epreuve.name}</Typography>
                                    </Box>
                                ))}
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        )}
    </Box>
)


}

export default FormLive